import React from 'react';
import Dashboard from '../components/sections/Dashboard';
import Settings from '../components/sections/Settings';
import BillingHistory from '../components/sections/BillingHistory';
import Projects from '../pages/Projects/Projects';
import Resources from '../pages/Resources/Resources';
import Monitoring from '../pages/Monitoring/Monitoring';
import Docs from '../pages/Docs/Docs';
import NotFound from '../pages/NotFound';
import CreateVM from '../pages/VirtualMachines/CreateVM';
import CreateVMPricing from '../pages/VirtualMachines/CreateVMPricing';
import CreateDatabase from '../pages/Databases/CreateDatabase';
import CreateWordPress from '../pages/Sites/CreateWordPress';
import CreateProject from '../pages/Projects/CreateProject';
import CreateDeployApp from '../pages/DeployApps/CreateDeployApp';
import CreateDeployAppServerPricing from '../pages/DeployApps/CreateDeployAppServerPricing';
import RootRedirect from '../components/RootRedirect';
import DeployApps from '../pages/DeployApps/DeployApps';
import DeployAppDetail from '../pages/DeployApps/DeployAppDetail';
import Sites from '../pages/Sites/Sites';
import SiteDetail from '../pages/Sites/SiteDetail';
import CreateSite from '../pages/Sites/CreateSite';
import Stacks from '../pages/Stacks/Stacks';
import CreateStack from '../pages/Stacks/CreateStack';
import VirtualMachines from '../pages/VirtualMachines/VirtualMachines';
import VMDetail from '../pages/VirtualMachines/VMDetail';
import Databases from '../pages/Databases/Databases';
import DatabaseDetail from '../pages/Databases/DatabaseDetail';
import PrivateRoute from '../components/PrivateRoute';
import WordPressSuccess from '../pages/WordPress/WordPressSuccess';
import WordPressEnvironments from '../pages/WordPress/WordPressEnviroments';
import WordPressDeployment from '../pages/WordPress/WordPressDeployment';
import PaymentSelection from '../pages/PaymentSelection/PaymentSelection';
import SsmTerminal from '../pages/VirtualMachines/Terminal';
import AllServices from '../pages/AllServices/AllServices';
import ServiceDetailPage from '../pages/ServiceDetail/ServiceDetailPage';
import Orders from '../pages/Orders/Orders';
import OrderDetail from '../pages/Orders/OrderDetail';
import TemplateEditor from '../pages/DeployApps/TemplateEditor';
import GitHubCallback from '../pages/GitHub/GitHubCallback';
import ChatbotIA from '../pages/ChatbotIA/ChatbotIA';
import CreateChatbotIA from '../pages/ChatbotIA/CreateChatbotIA';
import ChatbotDetail from '../pages/ChatbotIA/ChatbotDetail';
import DocsAssistant from '../pages/DocsAssistant/DocsAssistant';
import DocsDeployApps from '../pages/DocsAssistant/DocsDeployApps';
import DocsVM from '../pages/DocsAssistant/DocsVM';
import DocsDatabase from '../pages/DocsAssistant/DocsDatabase';
import DocsRabbitMQ from '../pages/DocsAssistant/DocsRabbitMQ';
import DocsN8N from '../pages/DocsAssistant/DocsN8N';
import CreateRabbitMQ from '../pages/RabbitMQ/CreateRabbitMQ';
import RabbitMQDetail from '../pages/RabbitMQ/RabbitMQDetail';
import CreateN8N from '../pages/N8N/CreateN8N';
import N8NDetail from '../pages/N8N/N8NDetail';
import CreateStrapi from '../pages/Strapi/CreateStrapi';
import StrapiDetail from '../pages/Strapi/StrapiDetail';
import CreateMedusa from '../pages/Medusa/CreateMedusa';
import MedusaDetail from '../pages/Medusa/MedusaDetail';
import CreateOdoo from '../pages/Odoo/CreateOdoo';
import OdooDetail from '../pages/Odoo/OdooDetail';
import CreateIdurar from '../pages/Idurar/CreateIdurar';
import IdurarDetail from '../pages/Idurar/IdurarDetail';
import CreateFrappeEducation from '../pages/FrappeEducation/CreateFrappeEducation';
import FrappeEducationDetail from '../pages/FrappeEducation/FrappeEducationDetail';
import CreateMetabase from '../pages/Metabase/CreateMetabase';
import MetabaseDetail from '../pages/Metabase/MetabaseDetail';
import CreateClickHouse from '../pages/ClickHouse/CreateClickHouse';
import ClickHouseDetail from '../pages/ClickHouse/ClickHouseDetail';
import CreateToolJet from '../pages/ToolJet/CreateToolJet';
import ToolJetDetail from '../pages/ToolJet/ToolJetDetail';
import CreateGhost from '../pages/Ghost/CreateGhost';
import GhostDetail from '../pages/Ghost/GhostDetail';
import CreateRedis from '../pages/Redis/CreateRedis';
import RedisDetail from '../pages/Redis/RedisDetail';
import CreateOnyx from '../pages/Onyx/CreateOnyx';
import OnyxDetail from '../pages/Onyx/OnyxDetail';
import CreateDockerHost from '../pages/DockerHost/CreateDockerHost';
import DockerHostDetail from '../pages/DockerHost/DockerHostDetail';
import CreateWordPressMarketplace from '../pages/WordPress/CreateWordPress';
import WordPressDetail from '../pages/WordPress/WordPressDetail';
import CreateSqlServer from '../pages/SqlServer/CreateSqlServer';
import SqlServerDetail from '../pages/SqlServer/SqlServerDetail';
import MarketplacePage from '../pages/Marketplace/MarketplacePage';
import { Navigate } from 'react-router-dom';

export interface RouteConfig {
  path: string;
  element: React.ReactElement;
  title?: string;
  protected?: boolean;
}

export const routes: RouteConfig[] = [
  {
    path: '/',
    element: <RootRedirect />,
    title: 'Home',
    protected: false,
  },
  {
    path: '/dashboard',
    element: <PrivateRoute><Dashboard /></PrivateRoute>,
    title: 'Dashboard',
    protected: true,
  },
  {
    path: '/projects',
    element: <PrivateRoute><Projects /></PrivateRoute>,
    title: 'Projects',
    protected: true,
  },
  {
    path: '/projects/create',
    element: <PrivateRoute><CreateProject /></PrivateRoute>,
    title: 'Create Project',
    protected: true,
  },
  {
    path: '/projects/deploy',
    element: <PrivateRoute><CreateDeployAppServerPricing /></PrivateRoute>,
    title: 'Deploy App',
    protected: true,
  },
  {
    path: '/deploy-apps/create',
    element: <PrivateRoute><CreateDeployAppServerPricing /></PrivateRoute>,
    title: 'Create Deploy App',
    protected: true,
  },
  {
    path: '/projects/deploy-legacy',
    element: <PrivateRoute><CreateDeployApp /></PrivateRoute>,
    title: 'Deploy App Legacy',
    protected: true,
  },
  {
    path: '/deploy-apps/create-legacy',
    element: <PrivateRoute><CreateDeployApp /></PrivateRoute>,
    title: 'Create Deploy App Legacy',
    protected: true,
  },
  {
    path: '/deploy-apps',
    element: <PrivateRoute><DeployApps /></PrivateRoute>,
    title: 'Deploy Apps',
    protected: true,
  },
  {
    path: '/deploy-apps/:id',
    element: <PrivateRoute><DeployAppDetail /></PrivateRoute>,
    title: 'Deploy App Detail',
    protected: true,
  },
  {
    path: '/deploy-apps/:id/editor',
    element: <PrivateRoute><TemplateEditor /></PrivateRoute>,
    title: 'Template Editor',
    protected: true,
  },
  {
    path: '/deploy-apps/terminal/:id',
    element: <PrivateRoute><SsmTerminal /></PrivateRoute>,
    title: 'Deploy App Terminal',
    protected: true,
  },
  {
    path: '/sites',
    element: <PrivateRoute><Sites /></PrivateRoute>,
    title: 'Sites',
    protected: true,
  },
  {
    path: '/sites/:id',
    element: <PrivateRoute><SiteDetail /></PrivateRoute>,
    title: 'Site Detail',
    protected: true,
  },
  {
    path: '/sites/create',
    element: <PrivateRoute><CreateSite /></PrivateRoute>,
    title: 'Create Site',
    protected: true,
  },
  {
    path: '/stacks',
    element: <PrivateRoute><Stacks /></PrivateRoute>,
    title: 'App Server',
    protected: true,
  },
  {
    path: '/stacks/create',
    element: <PrivateRoute><CreateStack /></PrivateRoute>,
    title: 'Create App Server',
    protected: true,
  },
  {
    path: '/resources',
    element: <PrivateRoute><Resources /></PrivateRoute>,
    title: 'Resources',
    protected: true,
  },
  {
    path: '/virtual-machines',
    element: <PrivateRoute><VirtualMachines /></PrivateRoute>,
    title: 'Virtual Machines',
    protected: true,
  },
  {
    path: '/virtual-machines/:id',
    element: <PrivateRoute><VMDetail /></PrivateRoute>,
    title: 'VM Detail',
    protected: true,
  },
  {
    path: '/virtual-machines/terminal/:id',
    element: <PrivateRoute><SsmTerminal /></PrivateRoute>,
    title: 'Terminal',
    protected: true,
  },
  {
    path: '/databases',
    element: <PrivateRoute><Databases /></PrivateRoute>,
    title: 'Databases',
    protected: true,
  },
  {
    path: '/databases/:id',
    element: <PrivateRoute><DatabaseDetail /></PrivateRoute>,
    title: 'Database Detail',
    protected: true,
  },
  {
    path: '/terminal',
    element:<SsmTerminal />,
    title: 'Terminal',
    protected: true,
  },
  {
    path: '/monitoring',
    element: <PrivateRoute><Monitoring /></PrivateRoute>,
    title: 'Monitoring',
    protected: true,
  },
  {
    path: '/docs',
    element: <PrivateRoute><Docs /></PrivateRoute>,
    title: 'Documentation',
    protected: true,
  },
  {
    path: '/settings',
    element: <PrivateRoute><Settings /></PrivateRoute>,
    title: 'Settings',
    protected: true,
  },
  {
    path: '/settings/billing',
    element: <PrivateRoute><BillingHistory /></PrivateRoute>,
    title: 'Billing History',
    protected: true,
  },
  {
    path: '/resources/create-vm',
    element: <PrivateRoute><CreateVMPricing /></PrivateRoute>,
    title: 'Create Virtual Machine',
    protected: true,
  },
  {
    path: '/resources/create-vm-legacy',
    element: <PrivateRoute><CreateVM /></PrivateRoute>,
    title: 'Create Virtual Machine Legacy',
    protected: true,
  },
  {
    path: '/resources/create-database',
    element: <PrivateRoute><CreateDatabase /></PrivateRoute>,
    title: 'Create Database',
    protected: true,
  },
  {
    path: '/resources/create-wordpress',
    element: <PrivateRoute><CreateWordPress /></PrivateRoute>,
    title: 'Create WordPress',
    protected: true,
  },
  {
    path: '/resources/wordpress-deployment',
    element: <PrivateRoute><WordPressDeployment /></PrivateRoute>,
    title: 'WordPress Deployment',
    protected: true,
  },
  {
    path: '/resources/wordpress-success/:id',
    element: <PrivateRoute><WordPressSuccess /></PrivateRoute>,
    title: 'WordPress Ready',
    protected: true,
  },
  {
    path: '/wordpress/environments',
    element: <PrivateRoute><WordPressEnvironments /></PrivateRoute>,
    title: 'WordPress Environments',
    protected: true,
  },
  {
    path: '/payment-selection/:orderId',
    element: <PrivateRoute><PaymentSelection /></PrivateRoute>,
    title: 'Payment Selection',
    protected: true,
  },
  {
    path: '/services',
    element: <PrivateRoute><AllServices /></PrivateRoute>,
    title: 'All Services',
    protected: true,
  },
  {
    path: '/services/:id',
    element: <PrivateRoute><ServiceDetailPage /></PrivateRoute>,
    title: 'Service Detail',
    protected: true,
  },
  {
    path: '/orders',
    element: <PrivateRoute><Orders /></PrivateRoute>,
    title: 'Orders',
    protected: true,
  },
  {
    path: '/orders/:id',
    element: <PrivateRoute><OrderDetail /></PrivateRoute>,
    title: 'Order Detail',
    protected: true,
  },
  {
    path: '/chatbot-ia',
    element: <PrivateRoute><ChatbotIA /></PrivateRoute>,
    title: 'Chatbot IA',
    protected: true,
  },
  {
    path: '/chatbot-ia/:id',
    element: <PrivateRoute><ChatbotDetail /></PrivateRoute>,
    title: 'Chatbot Detail',
    protected: true,
  },
  {
    path: '/chatbot-ia/create',
    element: <PrivateRoute><CreateChatbotIA /></PrivateRoute>,
    title: 'Create Chatbot IA',
    protected: true,
  },
  {
    path: '/marketplace',
    element: <PrivateRoute><MarketplacePage /></PrivateRoute>,
    title: 'Marketplace',
    protected: true,
  },
  {
    path: '/rabbitmq',
    element: <Navigate to="/marketplace?product=rabbitmq" replace />,
    title: 'RabbitMQ',
  },
  {
    path: '/rabbitmq/create',
    element: <PrivateRoute><CreateRabbitMQ /></PrivateRoute>,
    title: 'Create RabbitMQ',
    protected: true,
  },
  {
    path: '/rabbitmq/:id',
    element: <PrivateRoute><RabbitMQDetail /></PrivateRoute>,
    title: 'RabbitMQ Detail',
    protected: true,
  },
  {
    path: '/rabbitmq/terminal/:id',
    element: <PrivateRoute><SsmTerminal /></PrivateRoute>,
    title: 'RabbitMQ Terminal',
    protected: true,
  },
  {
    path: '/n8n',
    element: <Navigate to="/marketplace?product=n8n" replace />,
    title: 'n8n',
  },
  {
    path: '/n8n/create',
    element: <PrivateRoute><CreateN8N /></PrivateRoute>,
    title: 'Create n8n',
    protected: true,
  },
  {
    path: '/n8n/:id',
    element: <PrivateRoute><N8NDetail /></PrivateRoute>,
    title: 'n8n Detail',
    protected: true,
  },
  {
    path: '/strapi',
    element: <Navigate to="/marketplace?product=strapi" replace />,
    title: 'Strapi CMS',
  },
  {
    path: '/strapi/create',
    element: <PrivateRoute><CreateStrapi /></PrivateRoute>,
    title: 'Create Strapi CMS',
    protected: true,
  },
  {
    path: '/strapi/:id',
    element: <PrivateRoute><StrapiDetail /></PrivateRoute>,
    title: 'Strapi Detail',
    protected: true,
  },
  {
    path: '/strapi/terminal/:id',
    element: <PrivateRoute><SsmTerminal /></PrivateRoute>,
    title: 'Strapi Terminal',
    protected: true,
  },
  {
    path: '/medusa',
    element: <Navigate to="/marketplace?product=medusa" replace />,
    title: 'Medusa',
  },
  {
    path: '/medusa/create',
    element: <PrivateRoute><CreateMedusa /></PrivateRoute>,
    title: 'Create Medusa',
    protected: true,
  },
  {
    path: '/medusa/:id',
    element: <PrivateRoute><MedusaDetail /></PrivateRoute>,
    title: 'Medusa Detail',
    protected: true,
  },
  {
    path: '/medusa/terminal/:id',
    element: <PrivateRoute><SsmTerminal /></PrivateRoute>,
    title: 'Medusa Terminal',
    protected: true,
  },
  {
    path: '/onyx',
    element: <Navigate to="/marketplace?product=onyx" replace />,
    title: 'Onyx',
  },
  {
    path: '/onyx/create',
    element: <PrivateRoute><CreateOnyx /></PrivateRoute>,
    title: 'Create Onyx',
    protected: true,
  },
  {
    path: '/onyx/:id',
    element: <PrivateRoute><OnyxDetail /></PrivateRoute>,
    title: 'Onyx Detail',
    protected: true,
  },
  {
    path: '/onyx/terminal/:id',
    element: <PrivateRoute><SsmTerminal /></PrivateRoute>,
    title: 'Onyx Terminal',
    protected: true,
  },
  {
    path: '/odoo',
    element: <Navigate to="/marketplace?product=odoo" replace />,
    title: 'Odoo',
  },
  {
    path: '/odoo/create',
    element: <PrivateRoute><CreateOdoo /></PrivateRoute>,
    title: 'Create Odoo',
    protected: true,
  },
  {
    path: '/odoo/:id',
    element: <PrivateRoute><OdooDetail /></PrivateRoute>,
    title: 'Odoo Detail',
    protected: true,
  },
  {
    path: '/odoo/terminal/:id',
    element: <PrivateRoute><SsmTerminal /></PrivateRoute>,
    title: 'Odoo Terminal',
    protected: true,
  },
  {
    path: '/idurar',
    element: <Navigate to="/marketplace?product=idurar" replace />,
    title: 'IDURAR',
  },
  {
    path: '/idurar/create',
    element: <PrivateRoute><CreateIdurar /></PrivateRoute>,
    title: 'Create IDURAR',
    protected: true,
  },
  {
    path: '/idurar/:id',
    element: <PrivateRoute><IdurarDetail /></PrivateRoute>,
    title: 'IDURAR Detail',
    protected: true,
  },
  {
    path: '/idurar/terminal/:id',
    element: <PrivateRoute><SsmTerminal /></PrivateRoute>,
    title: 'IDURAR Terminal',
    protected: true,
  },
  {
    path: '/frappe-education',
    element: <Navigate to="/marketplace?product=frappe-education" replace />,
    title: 'Frappe Education',
  },
  {
    path: '/frappe-education/create',
    element: <PrivateRoute><CreateFrappeEducation /></PrivateRoute>,
    title: 'Create Frappe Education',
    protected: true,
  },
  {
    path: '/frappe-education/:id',
    element: <PrivateRoute><FrappeEducationDetail /></PrivateRoute>,
    title: 'Frappe Education Detail',
    protected: true,
  },
  {
    path: '/frappe-education/terminal/:id',
    element: <PrivateRoute><SsmTerminal /></PrivateRoute>,
    title: 'Frappe Education Terminal',
    protected: true,
  },
  {
    path: '/metabase',
    element: <Navigate to="/marketplace?product=metabase" replace />,
    title: 'Metabase',
  },
  {
    path: '/metabase/create',
    element: <PrivateRoute><CreateMetabase /></PrivateRoute>,
    title: 'Create Metabase',
    protected: true,
  },
  {
    path: '/metabase/:id',
    element: <PrivateRoute><MetabaseDetail /></PrivateRoute>,
    title: 'Metabase Detail',
    protected: true,
  },
  {
    path: '/metabase/terminal/:id',
    element: <PrivateRoute><SsmTerminal /></PrivateRoute>,
    title: 'Metabase Terminal',
    protected: true,
  },
  {
    path: '/clickhouse',
    element: <Navigate to="/marketplace?product=clickhouse" replace />,
    title: 'ClickHouse',
  },
  {
    path: '/clickhouse/create',
    element: <PrivateRoute><CreateClickHouse /></PrivateRoute>,
    title: 'Create ClickHouse',
    protected: true,
  },
  {
    path: '/clickhouse/:id',
    element: <PrivateRoute><ClickHouseDetail /></PrivateRoute>,
    title: 'ClickHouse Detail',
    protected: true,
  },
  {
    path: '/clickhouse/terminal/:id',
    element: <PrivateRoute><SsmTerminal /></PrivateRoute>,
    title: 'ClickHouse Terminal',
    protected: true,
  },
  {
    path: '/tooljet',
    element: <Navigate to="/marketplace?product=tooljet" replace />,
    title: 'ToolJet',
  },
  {
    path: '/tooljet/create',
    element: <PrivateRoute><CreateToolJet /></PrivateRoute>,
    title: 'Create ToolJet',
    protected: true,
  },
  {
    path: '/tooljet/:id',
    element: <PrivateRoute><ToolJetDetail /></PrivateRoute>,
    title: 'ToolJet Detail',
    protected: true,
  },
  {
    path: '/tooljet/terminal/:id',
    element: <PrivateRoute><SsmTerminal /></PrivateRoute>,
    title: 'ToolJet Terminal',
    protected: true,
  },
  {
    path: '/ghost',
    element: <Navigate to="/marketplace?product=ghost" replace />,
    title: 'Ghost CMS',
  },
  {
    path: '/ghost/create',
    element: <PrivateRoute><CreateGhost /></PrivateRoute>,
    title: 'Create Ghost CMS',
    protected: true,
  },
  {
    path: '/ghost/:id',
    element: <PrivateRoute><GhostDetail /></PrivateRoute>,
    title: 'Ghost Detail',
    protected: true,
  },
  {
    path: '/ghost/terminal/:id',
    element: <PrivateRoute><SsmTerminal /></PrivateRoute>,
    title: 'Ghost Terminal',
    protected: true,
  },
  {
    path: '/redis',
    element: <Navigate to="/marketplace?product=redis" replace />,
    title: 'Redis',
  },
  {
    path: '/redis/create',
    element: <PrivateRoute><CreateRedis /></PrivateRoute>,
    title: 'Create Redis',
    protected: true,
  },
  {
    path: '/redis/:id',
    element: <PrivateRoute><RedisDetail /></PrivateRoute>,
    title: 'Redis Detail',
    protected: true,
  },
  {
    path: '/redis/terminal/:id',
    element: <PrivateRoute><SsmTerminal /></PrivateRoute>,
    title: 'Redis Terminal',
    protected: true,
  },
  {
    path: '/docker-host',
    element: <Navigate to="/marketplace?product=docker-host" replace />,
    title: 'Docker Host',
  },
  {
    path: '/docker-host/create',
    element: <PrivateRoute><CreateDockerHost /></PrivateRoute>,
    title: 'Create Docker Host',
    protected: true,
  },
  {
    path: '/docker-host/:id',
    element: <PrivateRoute><DockerHostDetail /></PrivateRoute>,
    title: 'Docker Host Detail',
    protected: true,
  },
  {
    path: '/docker-host/terminal/:id',
    element: <PrivateRoute><SsmTerminal /></PrivateRoute>,
    title: 'Docker Host Terminal',
    protected: true,
  },
  {
    path: '/wordpress',
    element: <Navigate to="/marketplace?product=wordpress" replace />,
    title: 'WordPress',
  },
  {
    path: '/wordpress/create',
    element: <PrivateRoute><CreateWordPressMarketplace /></PrivateRoute>,
    title: 'Create WordPress',
    protected: true,
  },
  {
    path: '/wordpress/:id',
    element: <PrivateRoute><WordPressDetail /></PrivateRoute>,
    title: 'WordPress Detail',
    protected: true,
  },
  {
    path: '/wordpress/terminal/:id',
    element: <PrivateRoute><SsmTerminal /></PrivateRoute>,
    title: 'WordPress Terminal',
    protected: true,
  },
  {
    path: '/sqlserver',
    element: <Navigate to="/marketplace?product=sqlserver" replace />,
    title: 'SQL Server Express',
  },
  {
    path: '/sqlserver/create',
    element: <PrivateRoute><CreateSqlServer /></PrivateRoute>,
    title: 'Create SQL Server Express',
    protected: true,
  },
  {
    path: '/sqlserver/:id',
    element: <PrivateRoute><SqlServerDetail /></PrivateRoute>,
    title: 'SQL Server Detail',
    protected: true,
  },
  {
    path: '/sqlserver/terminal/:id',
    element: <PrivateRoute><SsmTerminal /></PrivateRoute>,
    title: 'SQL Server Terminal',
    protected: true,
  },
  {
    path: '/docs/assistant',
    element: <DocsAssistant />,
    title: 'Assistant Documentation',
    protected: false,
  },
  {
    path: '/docs/deploy-apps',
    element: <DocsDeployApps />,
    title: 'Deploy Apps Documentation',
    protected: false,
  },
  {
    path: '/docs/virtual-machines',
    element: <DocsVM />,
    title: 'Virtual Machines Documentation',
    protected: false,
  },
  {
    path: '/docs/databases',
    element: <DocsDatabase />,
    title: 'Databases Documentation',
    protected: false,
  },
  {
    path: '/docs/rabbitmq',
    element: <DocsRabbitMQ />,
    title: 'RabbitMQ Documentation',
    protected: false,
  },
  {
    path: '/docs/n8n',
    element: <DocsN8N />,
    title: 'n8n Documentation',
    protected: false,
  },
  {
    path: '/github-callback',
    element: <GitHubCallback />,
    title: 'GitHub Callback',
    protected: false, // No protegido porque necesita procesar antes de verificar auth
  },
  // El admin dashboard vive ahora en la app independiente kubiy-admin-ui
  {
    path: '*',
    element: <NotFound />,
    title: '404',
  },
];